import React, { Component } from 'react'
import Typography from 'material-ui/Typography'
import Paper from 'material-ui/Paper'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
const Unauthorized = (props) => {

  const {
    classes,
    translate
  } = props

  return (
    <Paper className={classes.paper}>
          <Typography>
            You don't have authorization to view this page
          </Typography>
    </Paper>
  )
}

export default withStyles(styles)(Unauthorized)



// WEBPACK FOOTER //
// ./src/components/unauthorized/index.js